import React, { useState } from "react";
import PropTypes from "prop-types";
import CSSTransition from "deprecated-react-transition-group/CSSTransitionGroup";
import classnames from "classnames";

import Dropdown from "apps/messages/components/Dropdown";
import ClickWatcher from "shared/components/ClickWatcher";

import MessagesButtonContent from "routers/Desktop/NavBar/components/MessagesButtonContent";
import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";

const MessagesButton = ({ isSelected, messagesCount }) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const close = () => setIsDropdownOpen(false);
	const toggle = () => setIsDropdownOpen((isOpen) => !isOpen);

	return (
		<ClickWatcher
			className="navbar-message"
			onOutsideClick={close}
			active={isDropdownOpen}
		>
			<button
				className={classnames("navbar-message-btn", {
					"navbar-message-btn--is-open": isDropdownOpen,
				})}
				onClick={(event) => {
					event.preventDefault();

					if (!isDropdownOpen) {
						selectedOptionOnNavBarEvent("Conversations Dropdown");
					}

					toggle();
				}}
			>
				<MessagesButtonContent
					messagesCount={messagesCount}
					isSelected={isSelected}
				/>
			</button>
			<CSSTransition
				transitionName="profile-menu"
				transitionAppear
				transitionAppearTimeout={200}
				transitionEnterTimeout={200}
				transitionLeaveTimeout={200}
			>
				{isDropdownOpen && (
					<Dropdown
						key="messages-dropdown"
						isOpen={isDropdownOpen}
						setIsOpen={setIsDropdownOpen}
					/>
				)}
			</CSSTransition>
		</ClickWatcher>
	);
};

MessagesButton.defaultProps = {
	isSelected: false,
	messagesCount: null,
};

MessagesButton.propTypes = {
	isSelected: PropTypes.bool,
	messagesCount: PropTypes.number,
};

export default MessagesButton;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/MessagesButton.jsx